var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._v("差戻し日時："+_vm._s(_vm.toWarekiDatetime(_vm.remand.updated_at)))]),_c('div',{staticClass:"mb-2"},[_vm._v("差戻し者："+_vm._s(_vm.remand.editor_staff.ibow_nickname))])])}
var staticRenderFns = []

export { render, staticRenderFns }